import request from '@/utils/request'
import { param } from 'jquery'
//学校界面整体数据查询接口
export function GetSchoolCha(data) {
  return request({
    url: '/html/school',
    method: 'post',
    data
  })
}

//快搜学校列表
export function GetPickupSchool(params) {
  return request({
    url: '/html/getLKuaiSouSchool',
    method: 'get',
    params
  })
}




// WEBPACK FOOTER //
// ./src/api/schoolcha.js